import {
  ALL_USERS_RES,
  CLEAR_SELF_PAY_CLAIM,
  CLEAR_SELF_PAY_CPT,
  CLEAR_SELF_PAY_EXPORT,
  ENDOFDAY_REPORT_RES,
  FILTER_APPOINTMENTLIST_REPORT_RES,
  FILTER_COLLECTION_REPORT_RES,
  FILTER_SELF_REPORT,
  PRIOR_REPORT_RES,
  SELF_PAY_PATIENT_EXPORT_SUCCESS,
  SELF_PAY_PATIENT_REPORT,
  SELF_PAY_PATIENT_REPORT_SUCCESS,
  SELF_PAY_PATIENT_SUCCESS_CLAIM,
  SELF_PAY_PATIENT_SUCCESS_CPT,
  PREVISIT_ESTIMATE_REPORT_REQUEST,
  PREVISIT_ESTIMATE_REPORT_SUCCESS,
  PREVISIT_ESTIMATE_EXPORT_REQUEST,
  PREVISIT_ESTIMATE_EXPORT_SUCCESS,
  CLEAR_PREVISIT_ESTIMATE_EXPORT,
  PREVISIT_ESTIMATE_DOWNLOAD_REQUEST,
  PREVISIT_ESTIMATE_DOWNLOAD_SUCCESS,
  CLEAR_PREVISIT_ESTIMATE_DOWNLOAD,
} from './reports.types'

const INITIAL_STATE = {
  endOfDayReport: null,
  appointmentListReport: null,
  collectionReport: null,
  allUsersData: null,
  priorReport: null,
  filterSelfReport: {
    firstname: '',
    lastname: '',
    dob: '',
    balance: '',
    startDate: '',
    endDate: '',
  },
  getSelPayPatient:null,
  getSelfPayExport:null,
  selfPayClaim:null,
  selfPayCPT:null,
  previsitEstimateReport: null,
  previsitEstimateExport: null,
  previsitEstimateDownload: null,
}

const reportReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ENDOFDAY_REPORT_RES: {
      return { ...state, ...{ endOfDayReport: action.payload } }
    }
    case FILTER_APPOINTMENTLIST_REPORT_RES: {
      return { ...state, ...{ appointmentListReport: action.payload } }
    }
    case FILTER_COLLECTION_REPORT_RES: {
      return { ...state, ...{ collectionReport: action.payload } }
    }
    case ALL_USERS_RES: {
      return { ...state, ...{ allUsersData: action.payload } }
    }
    case PRIOR_REPORT_RES: {
      return { ...state, ...{ priorReport: action.payload } }
    }
    case FILTER_SELF_REPORT:{
      return {...state,...{ filterSelfReport:action.payload }}
    }
    case SELF_PAY_PATIENT_REPORT_SUCCESS:{
      return {...state, getSelPayPatient:action.payload}
    }
    case SELF_PAY_PATIENT_EXPORT_SUCCESS:{
      return {...state, getSelfPayExport:action.payload}
    }
    case CLEAR_SELF_PAY_EXPORT : {
      return {...state, getSelfPayExport:null}
    }
    case SELF_PAY_PATIENT_SUCCESS_CLAIM:{
      return { ...state, selfPayClaim :action.payload }
    }
    case SELF_PAY_PATIENT_SUCCESS_CPT:{
      return { ...state, selfPayCPT :action.payload }
    }
    case CLEAR_SELF_PAY_CLAIM :{
      return {...state,selfPayClaim:null}
    }
    case CLEAR_SELF_PAY_CPT:{
      return {...state,selfPayCPT:null}
    }
    case PREVISIT_ESTIMATE_REPORT_REQUEST:{
      return {...state, previsitEstimateReport: null}
    }
    case PREVISIT_ESTIMATE_REPORT_SUCCESS:{
      return {...state, previsitEstimateReport: action.payload}
    }
    case PREVISIT_ESTIMATE_EXPORT_REQUEST:{
      return {...state, previsitEstimateExport: null}
    }
    case PREVISIT_ESTIMATE_EXPORT_SUCCESS:{
      return {...state, previsitEstimateExport: action.payload}
    }
    case CLEAR_PREVISIT_ESTIMATE_EXPORT:{
      return {...state, previsitEstimateExport: null}
    }
    case PREVISIT_ESTIMATE_DOWNLOAD_REQUEST:{
      return {...state, previsitEstimateDownload: null}
    }
    case PREVISIT_ESTIMATE_DOWNLOAD_SUCCESS:{
      return {...state, previsitEstimateDownload: action.payload}
    }
    case CLEAR_PREVISIT_ESTIMATE_DOWNLOAD:{
      return {...state, previsitEstimateDownload: null}
    }

    default:
      return state
  }
}

export default reportReducer
